var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"client-connect"},[(_vm.hasAccessToClientConnect())?_c('router-view'):_c('AccessDenied',{attrs:{"item":'Client Connect'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }